export default __webpack_public_path__ + "static/media/mob.167fd7f3.png";